import { useEffect, useState } from "react";
import { getLoggedinUser } from "../../helpers/api_helper";

const useProfile = () => {
  const userProfileSession = getLoggedinUser();
  console.warn("🔥 useProfile hook - getLoggedinUser returned:", userProfileSession);
  
  var token =
  userProfileSession &&
  userProfileSession["token"];
  const [loading, setLoading] = useState(userProfileSession ? false : true);
  const [userProfile, setUserProfile] = useState(
    userProfileSession ? userProfileSession : null
  );
  
  console.warn("🔥 useProfile initial state - userProfile:", userProfile, "isAdmin:", userProfile?.isAdmin);

  useEffect(() => {
    const userProfileSession = getLoggedinUser();
    var token =
      userProfileSession &&
      userProfileSession["token"];
    setUserProfile(userProfileSession ? userProfileSession : null);
    setLoading(token ? false : true);
  }, []);

  // Listen for storage changes across tabs (handles login/logout in other tabs)
  useEffect(() => {
    const handleStorageChange = () => {
      const userProfileSession = getLoggedinUser();
      var token =
        userProfileSession &&
        userProfileSession["token"];
      setUserProfile(userProfileSession ? userProfileSession : null);
      setLoading(token ? false : true);
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return { userProfile, loading,token };
};

export { useProfile };